import React from 'react';
import { Icon as ReactIcon } from '@a-ui/react';
import { translate } from '../../i18n';
import Typography from '../Typography';
import { passwordRequirements } from './config';

interface PasswordRequirementsProps {
  errors?: string[];
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ errors }) => {
  return (
    <>
      {passwordRequirements.map((requirement) => {
        const hasErrors = !errors || errors?.includes(requirement.error);

        return (
          <Typography
            key={requirement.label}
            classNames={[
              'ckp-m-password-requirement',
              `u-text-${hasErrors ? 'danger' : 'success'}`,
            ]}
          >
            <Typography variant="span" classNames="u-screen-reader-only">
              {translate(hasErrors ? 'password.requirements.unmet' : 'password.requirements.met')}
            </Typography>
            <Typography variant="span">{translate(requirement.label)}</Typography>
            <ReactIcon name={hasErrors ? 'ai-close' : 'ai-check-1'} />
          </Typography>
        );
      })}
    </>
  );
};

export default PasswordRequirements;
